import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

/** more colors to Theme Palette */
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    tertiary: Palette['primary'];
  }
  interface PaletteOptions {
    tertiary: PaletteOptions['primary'];
  }
  interface PaletteColor {
    lightshade?: string;
  }
  interface SimplePaletteColorOptions {
    lightshade?: string;
  }
}

/** Extend MUI Button Color parameter */
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    tertiary: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    tertiary: true;
  }
}

export const quipBlue = '#30a5e8';
export const quipRed = '#D7263D';

// Global Theme Styles
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#009ADF',
      // dark and light are calculated my MUI
      contrastText: '#ffffff',
      lightshade: '#d9f0fa',
    },
    secondary: red,
    tertiary: {
      main: '#3B8B43',
      dark: '#29612e',
      light: '#62a268',
      lightshade: '#d8ebda',
      contrastText: '#ffffff',
    },
  },
});
